export function fullUrl(path: string): string {
  const runtimeConfig = useRuntimeConfig();
  const hostName = runtimeConfig.public.hostName;
  if (process.env.NODE_ENV === 'development') {
    return `http://${hostName}${path}`;
  } else {
    return `https://${hostName}${path}`;
  }
}
